export const AUTHENTICATION = 'AUTH/authentication';
export const LOGIN = 'AUTH/login';

export const REGISTER = 'AUTH/register';
export const REGISTER_CONFIRM_OTP = 'AUTH/register_confirm_otp';
export const RESEND_SEND_OTP = 'AUTH/register_resend_otp';

export const FORGOT_PASSWORD = 'AUTH/forgot_password';
export const RESET_PASSWORD = 'AUTH/reset_password';
